import { render, staticRenderFns } from "./AddDocumentTypeModal.vue?vue&type=template&id=d952d590&scoped=true&"
import script from "./AddDocumentTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddDocumentTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentTypeModal.vue?vue&type=style&index=0&id=d952d590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d952d590",
  null
  
)

export default component.exports